import { IPricingOptionsObject } from "../services/menuItemController";
import { createValidationObject, isRequiredCheck } from "../yoello-lib/modules/dynamicForms/ValidationUtils";

const isRequiredKeys = ["name_public", "name_internal", "subcategory_id", "item_taxes"];
export function productValidationResolver(data: any) {
    const validationOutput: Record<string, any> = {};
    const pricing_options: IPricingOptionsObject = data.pricing_options;
    isRequiredCheck(isRequiredKeys, data, validationOutput);

    if (pricing_options) {
        for (const option of Object.values(pricing_options)) {
            if ((option.option_price as string).length === 0) {
                validationOutput["pricing_options"] = createValidationObject("pricing_options", "error")
            }
            if ((option.option_discount as number) < 0 || (option.option_discount as number) > 100) {
                validationOutput["pricing_options"] = createValidationObject("pricing_options", "error")
            }
        }
    }
    const hasErrors = !!Object.keys(validationOutput).length;

    return {
        values: hasErrors ? {} : data,
        errors: hasErrors ? validationOutput : {}
    }
}